import StepperComponent from "../../../components/Accounts/StepperComponent";
import { transferTypeHeadingData } from "../data";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import {
  ConfirmFundTransfer,
  createWireTransfer,
} from "../../../graphql/mutations/accounts";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { toast } from "react-toastify";
import TransferTypeHeading from "../../../components/Accounts/TransferTypeHeading";
import { TransferWrapper } from "../FipayTransfer";
import OtpPage from "../FipayTransfer/OtpPage";
import ScheduleTransferOption from "../FipayTransfer/ScheduleTransferOption";
import Summary from "../FipayTransfer/Summary";
import RecipientDetailsWireTransfer from "./RecipientDetailsWireTransfer";
import { WireTransferSteps, wireTransferPaymentSummary } from "./data";
import BusinessDetails from "./BusinessDetails";
import PaymentDetailsWireTransfer from "./PaymentDetailsWireTransfer";
import { resetFormValues } from "../../../store/formValues";
import { setLoading } from "../../../store/loadingSpinner";
import { resendOtp } from "../../../graphql/mutations/otp";

const WireTransfer = () => {
  const dispatch = useDispatch();
  const [stepNumber, setStepNumber] = useState(0);
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const [resendOtpAction] = useMutation(resendOtp);
  const { id, email } = useSelector(
    (state: RootState) => state.user?.user || {}
  );
  const emailFromStorage = email;
  const formValues = useSelector(
    (state: RootState) => state.formValues.wireTransfer
  );
  const [createWireTransferMutation, { loading: transferLoading }] =
    useMutation(createWireTransfer);

  const [ConfirmFundTransferMutation] = useMutation(ConfirmFundTransfer);

  const navigate = useNavigate();
  const handleNext = async () => {
    switch (stepNumber) {
      case 0:
        setStepNumber(stepNumber + 1);
        navigate(WireTransferSteps[stepNumber + 1].path);
        break;
      case 1:
        if (stepNumber < WireTransferSteps.length - 1) {
          setStepNumber(stepNumber + 1);
          navigate(WireTransferSteps[stepNumber + 1].path);
        }
        break;
      case 2:
        if (stepNumber < WireTransferSteps.length - 1) {
          setStepNumber(stepNumber + 1);
          navigate(WireTransferSteps[stepNumber + 1].path);
        }
        break;
      case 3:
        if (stepNumber < WireTransferSteps.length - 1) {
          setStepNumber(stepNumber + 1);
          navigate(WireTransferSteps[stepNumber + 1].path);
        }
        break;
      case 4:
        try {
          const response = await createWireTransferMutation({
            variables: {
              accountTransfer: {
                // userId: id,
                recipientFullName: formValues.RecipientLegalName,
                recipientPhoneNumber: formValues.RecipientPhoneNumber,
                purpose: formValues.Purpose,
                amount: formValues.Amount,
                recipientAddress: formValues.RecipientAddress,
                recipientType: formValues.RecipientType,
                recipientProfession: formValues.RecipientProfession,
                recipientCountry: formValues.RecipientCountry,
                recipientState: formValues.RecipientState,
                recipientCity: formValues.RecipientCity,
                scheduleEnabled: formValues.scheduleTransfer,
                iban: formValues.RecipientIBAN,
                swiftCode: formValues.RecipientSwiftCode,
                websiteOrLinkedinProfile: formValues.Website,
                memo: formValues.Memo,
                goodsAndServicesRecieved: formValues.GoodsType,
                attachedDocument: formValues.SupportingDoc,
                startDate: formValues.startDate,
                endDate: formValues.endDate,
                scheduleFrequency: formValues.period,
              },
            },
          });
          if (
            response.data.createWireTransfer.status === "success" &&
            stepNumber < WireTransferSteps.length - 1
          ) {
            setStepNumber(stepNumber + 1);
            navigate(WireTransferSteps[stepNumber + 1].path);
          }
          console.log("transfer-response", response);
        } catch (error) {
          console.error("Error creating transfer:", error);
        }
        break;
    }
  };

  const handlePrevious = (index: number) => {
    setStepNumber(index);
  };

  const handleOtpSubmit = async () => {
    dispatch(setLoading(true));
    try {
      const response = await ConfirmFundTransferMutation({
        variables: {
          otp: otpValues.join(""),
          // userId: id,
        },
      });
      if (response.data.confirmFundTransfer.status === "complete") {
        dispatch(resetFormValues());
        navigate("/dashboard/accounts");
        toast.success(
          `You've successfully sent $${formValues.Amount} to ${formValues.RecipientLegalName}`,
          {
            style: {
              background: "#DEF1DE",
              color: "#388233",
            },
          }
        );
      }
    } catch (error) {
      console.error("Error confirming transfer:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleResendOtp = async () => {
    if (!emailFromStorage) return;

    setOtpValues(["", "", "", "", "", ""]);
    try {
      const response = await resendOtpAction({
        variables: {
          email: emailFromStorage,
        },
      });
      if (
        response.data.resendOTPByEmail.message ===
        `OTP resent to ${emailFromStorage}`
      ) {
        toast.success("OTP sent successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error(error);
      toast.error("Invalid OTP or OTP expired", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const renderStepContent = (
    stepNumber: number,
    formValues: any
  ): JSX.Element => {
    switch (stepNumber) {
      case 0:
        return (
          <RecipientDetailsWireTransfer
            handleNext={handleNext}
            prevValues={formValues}
            transferType={"wireTransfer"}
          />
        );

      case 1:
        return (
          <BusinessDetails
            handleNext={handleNext}
            prevValues={formValues}
            transferType={"wireTransfer"}
          />
        );

      case 2:
        return (
          <PaymentDetailsWireTransfer
            handleNext={handleNext}
            prevValues={formValues}
            transferType={"wireTransfer"}
          />
        );

      case 3:
        return (
          <ScheduleTransferOption
            handleNext={handleNext}
            prevValues={formValues}
            transferType={"wireTransfer"}
          />
        );

      case 4:
        return (
          <Summary
            handleNext={handleNext}
            values={formValues}
            title={transferLoading ? "Loading..." : "Next"}
            paymentType={"Wire Transfer"}
            paymentSummary={wireTransferPaymentSummary}
          />
        );

      case 5:
        return (
          <OtpPage
            handleOtpSubmit={handleOtpSubmit}
            otpValues={otpValues}
            setOtpValues={setOtpValues}
            handleResendOtp={handleResendOtp}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <TransferWrapper>
      <TransferTypeHeading
        transferTitle={transferTypeHeadingData[2].transferTitle}
        transferSubTitle={transferTypeHeadingData[2].transferSubTitle}
      />
      <StepperComponent
        steps={WireTransferSteps}
        activeStep={stepNumber}
        onClick={handlePrevious}
      />
      {renderStepContent(stepNumber, formValues)}
    </TransferWrapper>
  );
};

export default WireTransfer;
